<div class="card add-group-card">
  <rqa-page-title [title]="(isEditMode ? 'groups.form.edit' : 'groups.form.add') | translate">
    <div class="flex justify-end align-items-center gap-2 mt-4">
      <button
        pButton
        type="button"
        variant="outlined"
        severity="secondary"
        [label]="'common.button.cancel' | translate"
        icon="pi pi-times"
        (click)="onCancel()"
        [disabled]="isSubmitting"
      ></button>

      <button
        pButton
        type="submit"
        [label]="(isEditMode ? 'common.button.save' : 'common.button.add') | translate"
        [icon]="isEditMode ? 'pi pi-check' : 'pi pi-plus'"
        [disabled]="groupForm.invalid || isSubmitting || selectedUsers.length === 0"
        [loading]="isSubmitting"
        (click)="onSubmit()"
      ></button>
    </div>
  </rqa-page-title>
  <div class="card-body">
    <form [formGroup]="groupForm" (ngSubmit)="onSubmit()">
      <div class="flex flex-row flex-wrap w-full gap-2">
        <div class="field flex-1">
          <label for="name" class="block mb-1 text-sm">
            {{ 'groups.form.name.label' | translate }}
            <span class="text-red-500">*</span>
          </label>

          <input
            pInputText
            id="name"
            formControlName="name"
            [placeholder]="'groups.form.name.placeholder' | translate"
            class="w-full"
          />
          <rqa-validator [control]="groupForm.get('name')"></rqa-validator>
        </div>
        <div class="field flex-1">
          <label for="group" class="block mb-1 text-sm"
            >{{ 'users.form.type' | translate }}<span class="text-red-500">*</span></label
          >
          <p-select
            id="group"
            [options]="groups()"
            formControlName="group"
            class="w-full"
            [placeholder]="'primeng.choose' | translate"
            (onChange)="onGroupChange($event)"
          ></p-select>
          <rqa-validator [control]="groupForm.get('groupValue')"></rqa-validator>
        </div>
      </div>

      <div class="field mt-2" *ngIf="groupForm.get('group')?.value">
        <p-table
          #groupUsersTable
          [value]="filteredUsers()"
          [scrollable]="true"
          [tableStyle]="{ 'min-width': '50rem' }"
          dataKey="username"
          [globalFilterFields]="['username', 'firstName', 'lastName', 'email', 'organization']"
          styleClass="p-datatable-sm"
          [loading]="usersLoading() || groupLoading()"
          [scrollHeight]="tableScrollHeight()"
          (selectionChange)="onSelectionChange($event)"
          [(selection)]="selectedUsers"
        >
          <ng-template #caption>
            <div class="flex flex-row justify-between">
              <h5 class="mb-0">
                {{ 'groups.form.users.label' | translate }} <span class="text-red-500">*</span>
                <p-badge [value]="selectedUsers.length"></p-badge>
              </h5>
              <p-iconfield iconPosition="left" class="ml-auto">
                <p-inputicon>
                  <i class="pi pi-search"></i>
                </p-inputicon>
                <input
                  pInputText
                  type="text"
                  (input)="filterGroupUsers($event, groupUsersTable)"
                  [placeholder]="'groups.users.search.placeholder' | translate"
                />
              </p-iconfield>
            </div>
            <p>{{ 'groups.form.users.description' | translate }}</p>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 3rem"></th>

              <th pSortableColumn="username">
                {{ 'groups.form.users.table.username' | translate }}

                <p-sortIcon field="username"></p-sortIcon>
              </th>

              <th pSortableColumn="firstName">
                {{ 'groups.form.users.table.firstName' | translate }}

                <p-sortIcon field="firstName"></p-sortIcon>
              </th>

              <th pSortableColumn="lastName">
                {{ 'groups.form.users.table.lastName' | translate }}

                <p-sortIcon field="lastName"></p-sortIcon>
              </th>
              <th pSortableColumn="responsibleUnit">
                {{ 'groups.form.users.table.responsibleUnit' | translate }}

                <p-sortIcon field="responsibleUnit"></p-sortIcon>
              </th>

              <th pSortableColumn="organization">
                {{ 'groups.form.users.table.organization' | translate }}

                <p-sortIcon field="organization"></p-sortIcon>
              </th>
              <th pSortableColumn="role">
                {{ 'groups.form.users.table.role' | translate }}

                <p-sortIcon field="role"></p-sortIcon>
              </th>
            </tr>
            <tr [formGroup]="filtersForm">
              <td colspan="4"></td>
              <td>
                <input
                  *ngIf="!selectedUsers.length"
                  pInputText
                  type="text"
                  [placeholder]="'groups.form.users.filters.responsibleUnit' | translate"
                  [formControlName]="'responsibleUnit'"
                />
              </td>
              <td>
                <input
                  pInputText
                  type="text"
                  [placeholder]="'groups.form.users.filters.organization' | translate"
                  [formControlName]="'organization'"
                />
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-user>
            <tr>
              <td>
                <p-tableCheckbox
                  [value]="user"
                  [disabled]="selectedResponsibleUnit && user.responsibleUnit !== selectedResponsibleUnit"
                ></p-tableCheckbox>
              </td>

              <td>{{ user.username }}</td>
              <td>{{ user.firstName }}</td>
              <td>{{ user.lastName }}</td>
              <td>{{ user.responsibleUnit }}</td>
              <td>{{ user.organization }}</td>
              <td>{{ user.role }}</td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="7" class="text-center">
                {{ 'groups.form.users.empty' | translate }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </form>
  </div>
</div>
